import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { reduxForm } from 'antd-form-redux';
import { Form, Input, Button } from 'antd';
import { notificacao } from '../master-page/redux/notificacao';

export class FormAlterarSenha extends Component {
  static propTypes = {
    acessoSistema: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  handleSubmit = e => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (err) return;

      this.props.actions.alterarSenha(values, action => {
        if (action === 'ACESSO_SISTEMA_ALTERAR_SENHA_SUCCESS') {
          notificacao(
            'success',
            'Senha alterada com sucesso!',
            'Necessário realizar login com a nova senha.',
            5,
          );
          localStorage.clear();
          this.props.history.push('/login');
        } else {
          const { error } = this.props.acessoSistema.alterarSenhaError.response.data;
          console.error(error);
          notificacao('error', error.message);
        }
      });
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      acessoSistema,
    } = this.props;
    return (
      <div className="acesso-sistema-form-alterar-senha">
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <Form.Item label="Senha atual">
            {getFieldDecorator('newPassword', {
              rules: [{ required: true, message: 'Campo obrigatório!' }],
            })(<Input type="password" placeholder="" />)}
          </Form.Item>
          <Form.Item label="Senha nova">
            {getFieldDecorator('oldPassword', {
              rules: [{ required: true, message: 'Campo obrigatório!' }],
            })(<Input type="password" placeholder="" />)}
          </Form.Item>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              icon="save"
              loading={acessoSistema.alterarSenhaPending}
            >
              <span>Salvar</span>
            </Button>
          </Form.Item>
          {/* <Form.Item>
            <Button block onClick={history.goBack} type="primary" htmlType="submit" icon="rollback" >
              <span>Voltar</span>
            </Button>
          </Form.Item> */}
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    acessoSistema: state.acessoSistema,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

FormAlterarSenha = reduxForm({
  form: 'Alterar-Senha',
})(FormAlterarSenha);

FormAlterarSenha = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormAlterarSenha);

export default FormAlterarSenha;



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/FormAlterarSenha.js